import axios from 'axios';

export default defineNuxtPlugin({
  enforce: 'pre', // or 'post',
  async setup(nuxtApp) {
    let api = axios.create({
      // baseUrl: defaultUrl,
      headers: {
        common: {},
        'x-distribution-channel': 'WEB',
      },
    });
    if (api && import.meta.server) {
      api.interceptors.response.use(
        async (response) => {
          // const logger = (await import('../logger')).default;

          // const tenant = response.config.headers['X-Tenant-ID'];
          // Any status code that lies within the range of 2xx causes this function to trigger
          // logger.info(
          //   `Axios resposne ${response.status} to [${response.config.method}] ${response.config.url}`,
          //   {
          //     ...response.headers,
          //     ...response.request?.headers,
          //     tenant:
          //       tenant || nuxtApp?.ssrContext?.event?.context?.tenant?.tenant,
          //     logger_name: 'axios',
          //   },
          // );
          return response;
        },
        async (error) => {
          const logger = (await import('../logger')).default;

          if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            logger.error(
              `Axios error: ${error.response.status} ${error.response.statusText} calling [${error.config.method}] ${error.config.url}`,
              { ...error.response.headers },
            );
          } else if (error.request) {
            // The request was made but no response was received
            logger.error(
              `Axios error: No response received, Request: ${JSON.stringify(error.request)}`,
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            logger.error(`Axios error: ${error.message}`);
          }
          return Promise.reject(error); // Forward the error to be handled elsewhere if needed
        },
      );
    }
        const asyncData = await useFetch('/api/envFile', {
          headers: useRequestHeaders(['host']), // Pass relevant headers
        });
    // api.interceptors.request.use((config) => {
    //     console.log('Axios: request ', config.url, config.headers);
    //     return config;
    // })
    const envFile = asyncData.data.value?.envConfig?.envFile;
    const tenantName = asyncData.data.value?.tenantName;

    let backendUrl;
    if (tenantName &&
      envFile?.service?.tenantBackendUrl?.[tenantName]
    ) {
      backendUrl =
        envFile.service.tenantBackendUrl[tenantName];
    } else {
      backendUrl = envFile?.service?.multiContentBackend;
    }
    api.interceptors.response.use(null,(response)=>{
      if (response?.status === 401){
        if (import.meta.server) {
          const { $login, $auth } = useNuxtApp();
          $auth.logout();
        }
        if (import.meta.client) {
          return location.reload();
        }
        return response;
      }else{        
        return Promise.reject(response);
      }
    })
    return {
      provide: {
        axios: api,
        backendLink: backendUrl,
        stage: envFile?.stage,
      },
    };
  },
});
